import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

export interface GuardState {
  isAuthenticated: boolean
  isAdmin: boolean
  mfaSetupRequired: boolean
  /** Выполнен ли первый запуск; null, если не проверяли (сервер недоступен). */
  setupCompleted: boolean | null
  /** Запуск без сети: сессию проверить нельзя, открывается оболочка (ТЗ 18.7). */
  offline?: boolean
}

const MFA_ROUTE = 'settings-security'

/**
 * Глобальный guard (ТЗ 18.3): гость уходит на вход с возвратом, вошедший с гостевых
 * экранов на главную, при обязательной 2FA открыт только экран безопасности,
 * экраны администратора закрыты остальным. Скрытие кнопок по роли лишь удобство,
 * права проверяет сервер.
 */
export function decide(
  to: Pick<RouteLocationNormalized, 'name' | 'meta' | 'fullPath'>,
  state: GuardState,
): true | RouteLocationRaw {
  if (state.setupCompleted === false && to.name !== 'setup') return { name: 'setup' }
  if (state.setupCompleted === true && to.name === 'setup') return { name: 'login' }

  if (to.meta.guestOnly && state.isAuthenticated) return { name: 'home' }
  if (to.meta.requiresAuth && state.offline) return true
  if (to.meta.requiresAuth && !state.isAuthenticated) {
    return to.fullPath === '/'
      ? { name: 'login' }
      : { name: 'login', query: { redirect: to.fullPath } }
  }
  if (state.mfaSetupRequired && to.meta.requiresAuth && to.name !== MFA_ROUTE)
    return { name: MFA_ROUTE }
  if (to.meta.admin && !state.isAdmin) return { name: 'forbidden' }

  return true
}
